// API Configuration
const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'https://clocking-system-api.youmck.com',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export default API_CONFIG; 